'use strict';

import _cloneDeep from "lodash/cloneDeep";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import FrontHeader from 'Components/Navigation/FrontHeader';
import Footer from 'Components/Navigation/Footer';
import config from 'Shared/config';
const app = window.app;
export default class Front extends Component {
  state = {
    og_img: document.location.origin + '/images/logo_myWO_full.png',
    og_alt: 'Logo myWO, vos espaces de coworking'
  };
  pathname = document.location.pathname;
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    app.push({
      event: 'setMetas',
      cb: component.setMetas
    });
  }
  componentWillUnmount() {
    const component = this,
      props = this.props,
      state = this.state;
    app.delete({
      event: 'setMetas',
      cb: component.setMetas
    });
  }
  componentDidUpdate(prev_props, prev_state) {
    const component = this,
      props = this.props,
      state = this.state;
    if (document.location.pathname !== component.pathname) {
      component.pathname = document.location.pathname;
      component.setState({
        title: config.site_name,
        description: config.meta_description
      });
    }
  }
  setMetas = ({
    source,
    data = {}
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    const update = _cloneDeep(data);
    if (update.og_image) {
      update.og_image = update.og_image.startsWith('http') ? update.og_image : document.location.origin + update.og_image;
    }
    component.setState(update);
  };
  handleDocClick = e => {
    const component = this,
      props = this.props,
      state = this.state;
    app.emit({
      event: 'documentClick',
      source: 'Layout'
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const meta_tags = /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("title", null, props.meta_title || state.title || config.site_name), /*#__PURE__*/React.createElement("meta", {
      name: "description",
      content: props.meta_description || state.description || config.meta_description
    }), /*#__PURE__*/React.createElement("meta", {
      property: "og:type",
      content: "website"
    }), /*#__PURE__*/React.createElement("meta", {
      property: "og:url",
      content: document.location.origin + document.location.pathname
    }), /*#__PURE__*/React.createElement("meta", {
      property: "og:title",
      content: props.meta_title || state.title
    }), /*#__PURE__*/React.createElement("meta", {
      property: "og:image",
      content: state.og_img
    }), /*#__PURE__*/React.createElement("meta", {
      property: "og:image:alt",
      content: state.og_alt
    }), props.meta_follow === true ? /*#__PURE__*/React.createElement("meta", {
      name: "robots",
      content: "index, follow"
    }) : /*#__PURE__*/React.createElement("meta", {
      name: "robots",
      content: "noindex, nofollow"
    }));
    let output = /*#__PURE__*/React.createElement("div", {
      className: "front-page",
      onClick: component.handleDocClick
    }, meta_tags, props['hide-header'] !== true ? /*#__PURE__*/React.createElement("div", {
      className: "front-page-header"
    }, /*#__PURE__*/React.createElement(FrontHeader, {
      bemit: props['header-bemit'],
      "hide-login": props['hide-login'],
      "hide-navbar": props['hide-navbar']
    })) : undefined, props.children, props['hide-bottom'] !== true ? /*#__PURE__*/React.createElement("div", {
      className: "page-bottom"
    }) : undefined, props['hide-footer'] !== true ? /*#__PURE__*/React.createElement(Footer, null, props['sub-footer']) : undefined);
    return output;
  }
}
Front.propTypes = {
  meta_follow: PropTypes.bool,
  meta_description: PropTypes.string,
  meta_title: PropTypes.string
};
Front.defaultProps = {
  meta_follow: true
};
